export const getDateUTCZeroHours = ({ subdays = 0, endOfDay = false }) => {
  const d = new Date()
  const utcDateZeroHours = new Date(
    Date.UTC(
      d.getFullYear(),
      d.getMonth(),
      d.getDate() - subdays,
      endOfDay ? 23 : 0,
      endOfDay ? 59 : 0,
      endOfDay ? 59 : 0
    )
  ).toISOString()
  return utcDateZeroHours
}
